import { render, staticRenderFns } from "./woongarant-insurance.vue?vue&type=template&id=0afc4bd8"
import script from "./woongarant-insurance.vue?vue&type=script&lang=ts"
export * from "./woongarant-insurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports